export default "__VITE_ASSET__BHhso0LS__";